export type $CalendarView = 'team' | 'day' | 'threeDay' | 'fiveDay' | 'week'
export type $CalendarZoomLevel = Exclude<$CalendarView, 'team'>

export const calendarZoomLevels: Array<$CalendarZoomLevel> = ['week', 'fiveDay', 'threeDay', 'day']

export interface $ViewConfig {
  daysInView: number
  dayNameFormat: string
}

export const viewConfig: Record<$CalendarView, $ViewConfig> = {
  team: {
    daysInView: 1,
    dayNameFormat: 'dddd',
  },
  week: {
    daysInView: 7,
    dayNameFormat: 'dddd',
  },
  day: {
    daysInView: 1,
    dayNameFormat: 'dddd',
  },
  threeDay: {
    daysInView: 3,
    dayNameFormat: 'dddd',
  },
  fiveDay: {
    daysInView: 5,
    dayNameFormat: 'dddd',
  },
}
